/**
 * @file コンポーネント：アカウントメニュー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledAccountmenu,
    StyledAccountmenuAnchor,
    StyledAccountmenuDetail,
    StyledAccountmenuDetailName,
    StyledAccountmenuItem,
    StyledAccountmenuLabel,
    StyledAccountmenuLabelRadio,
    StyledAccountmenuTerm,
    StyledAccountmenuTermName,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // SEO対応：URLに応じた言語URLリンク取得
    const getMypagePath = () => {
        const path = location.pathname;

        // /en/xxx or /ja/xxx
        const langMatch = path.match(/^\/(ja|en)\/([^/]+)/);
        if (langMatch) {
            return `/${langMatch[1]}/mypage`;
        }

        // /xxx
        const simpleMatch = path.match(/^\/([^/]+)/);
        return simpleMatch ? `/mypage` : "/";
    };

    // ReactDOM
    return (
        <StyledAccountmenu
            className={props.isOpenAccountmenu === true && "is-open"}
            ref={props.refAccountmenu}
        >
            {/* アカウント名 */}
            <StyledAccountmenuItem>
                <StyledAccountmenuTermName>
                    {localized["Label.AccountName"]}
                </StyledAccountmenuTermName>
                <StyledAccountmenuDetailName>
                    {window.dataUser.userName}
                </StyledAccountmenuDetailName>
            </StyledAccountmenuItem>
            {/* アカウントメニュー */}
            <StyledAccountmenuItem>
                <StyledAccountmenuTerm>
                    {localized["Label.AccountMenu"]}
                </StyledAccountmenuTerm>
                {props.isSponsorUser === false && (
                    // スポンサーユーザー以外の場合
                    <>
                        {/* アカウントメニュー：マイページ */}
                        <StyledAccountmenuDetail>
                            <StyledAccountmenuAnchor href={getMypagePath()}>
                                {localized["Label.Mypage"]}
                            </StyledAccountmenuAnchor>
                        </StyledAccountmenuDetail>
                        {/* アカウントメニュー：お問い合わせ */}
                        <StyledAccountmenuDetail>
                            <StyledAccountmenuAnchor
                                href="https://share.hsforms.com/1UJHSQWohTBeeS39vdvcNzAclqdg"
                                target="_blank"
                            >
                                {localized["Label.Contact"]}
                            </StyledAccountmenuAnchor>
                        </StyledAccountmenuDetail>
                    </>
                )}
                {/* アカウントメニュー：ログアウト */}
                <StyledAccountmenuDetail>
                    <StyledAccountmenuAnchor
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            props.setIsOpenAccountmenu(false);
                            props.setIsOpenModalLogout(true);
                        }}
                    >
                        {localized["Label.Logout"]}
                    </StyledAccountmenuAnchor>
                </StyledAccountmenuDetail>
            </StyledAccountmenuItem>
        </StyledAccountmenu>
    );
};
